import { compact, map } from 'lodash/fp';

import { Maybe, TermsAndConditions } from '../../types/__codegen__/sanity/graphql';

const mapTermsAndConditions = (cmsTermsAndConditions: Maybe<TermsAndConditions> | undefined) => {
  if (!cmsTermsAndConditions) {
    return [];
  }

  const footnotes = map((footnote) => {
    if (!footnote) {
      return null;
    }
    const { descriptionRaw, linkReferenceSymbol } = footnote;
    return {
      descriptionRaw,
      footnote: {
        linkId: `footnote-${linkReferenceSymbol}`,
        reference: linkReferenceSymbol || '',
      },
    };
  }, cmsTermsAndConditions.footnotes);

  return compact([{ ...cmsTermsAndConditions, title: cmsTermsAndConditions.name || null }, ...footnotes]);
};

export default mapTermsAndConditions;
